import { post, get, put, del } from "@/utils/request";


// 业务线列表
export function getBusinessLine(data) {
  return get("/api/exam/businessLine/getIdBydeptId", data);
}


// 题库列表
export function examQuestionRepoList(data) {
  return get("/api/exam/questionRepo/list", data);
}

// 添加题库
export function addExamQuestion(data) {
  return post("/api/exam/questionRepo", data);
}

// 添加题库
export function editExamQuestion(data) {
  return put("/api/exam/questionRepo", data);
}

// 删除题库
export function deleteExamQuestion(data) {
  return del("/api/exam/questionRepo/" + data.id);
}

// 获取当前用户创建或参与的项目
export function getProjectList(data) {
  return get("/api/exam/project/myProject", data);
}

// 题目列表
export function questionList(data) {
  return get("/api/exam/questions/" + data.questionRepoId + "/list", data);
}

// 各业务线下题目列表汇总
export function allQuestionList(data) {
  return get("/api/exam/questions/list", data);
}

// 创建题目
export function createQuestion(data) {
  return post("/api/exam/questions", data);
}

// 获取工作流id列表
export function getWorkFlowIdList(data) {
  return get("/services/app/WorkFlow/GetTemplateFlowVertexs", data);
}

// 获取dots项目列表
export function getDOTSProjectList(workTypeId) {
  return get("/api/exam/settings/projects", {workTypeId});
}


/**
 * 编辑题目
 * @param {题目数据信息} data 
 * @param {是否全量编辑} type 
 * @returns 
 */
export function editQuestion(data, type) {
  return put("/api/exam/questions/" + data.questions[0].questionRepoId + "?all=" + type, data);
}

// 删除题目
export function deleteQuestion(data) {
  return del("/api/exam/questions/" + data.id);
}

// 禁用题目 1启用，0禁用
export function changeQuestionStatus(data) {
  return put("/api/exam/questions/" + data.id + "/status?status=" + data.status);
}

/**
 * 获取资质小类
 */
export function getCategoryCode() {
  return get("/api/exam/qualification/getByQualificationCategory");
}

// 培训任务列表--考官端 -- 关联培训列表
export function examCultivateApi(data) {
  return get(`/api/exam/cultivate`, data);
}

// 负责人列表 -- 辅助考官
export function examAdminListApi() {
  return get(`/api/exam/admin/adminList`);
}

// 上传题目文件
export function uploadQuestion(data) {
  return post(`/api/exam/questions/uploadQuestion`, data);
}

export function getBatchId(questionRepoId) {
  return get("/api/exam/questions/batch?questionRepoId=" + questionRepoId);
}

export function getQuestionDetail(questionId) {
  return get("/api/exam/questions/question?questionId=" + questionId);
}

export function resetPreProcess(questionId) {
  return post(`/api/exam/questions/${questionId}/resetPreProcess`);
}